import React from 'react';
import { Linkedin, Github, Download } from 'lucide-react';
import { useLocation } from 'react-router-dom';

export default function Hero() {
    const location = useLocation();
    const isCVPage = location.pathname === '/cv';

    return (
        <section className="bg-gradient-to-r from-blue-800 to-blue-600 text-white py-12">
            <div className="container mx-auto px-4 flex flex-col md:flex-row items-center">
                <div className="md:w-1/3 mb-8 md:mb-0 flex justify-center">
                    <img
                        src="/avatar.png"
                        alt="Kritik Agarwal"
                        className="rounded-full w-48 h-48 object-cover border-4 border-white shadow-lg"
                    />
                </div>
                <div className="md:w-2/3 md:pl-12 text-center md:text-left">
                    <h1 className="text-4xl md:text-5xl font-bold mb-2">Kritik Agarwal</h1>
                    <h2 className="text-xl md:text-2xl mb-6">
                        M.Tech Computer Science & Engineering - TA
                    </h2>

                    {isCVPage && (
                        <div className="flex flex-wrap justify-center md:justify-start gap-4 mb-6">
                            <a
                                href="https://in.linkedin.com/in/AgarwalKritik"
                                className="flex items-center gap-2 bg-white text-blue-800 px-3 py-1 rounded-full hover:bg-blue-100 transition"
                                target="_blank" rel="noopener noreferrer"
                            >
                                <Linkedin size={16} /> /AgarwalKritik
                            </a>
                            <a
                                href="https://github.com/AgarwalKritik"
                                className="flex items-center gap-2 bg-white text-blue-800 px-3 py-1 rounded-full hover:bg-blue-100 transition"
                                target="_blank" rel="noopener noreferrer"
                            >
                                <Github size={16} /> /AgarwalKritik
                            </a>
                            <a
                                href="/KritikAgarwal_CV.pdf"
                                target="_blank"
                                rel="noopener noreferrer"
                                title="Open or download my resume"
                                className="flex items-center gap-2 bg-white text-blue-800 px-3 py-1 rounded-full hover:bg-blue-100 transition"
                            >
                                <Download size={16} /> View/Download CV
                            </a>
                        </div>
                    )}
                </div>
            </div>
        </section>
    );
}
